<template>
    <div style="background: white;">
        <div class="picker__title primary">
            <div class="date-picker-title">
                <div class="date-picker-title__date" style="color: white;">
                    Range: {{ range }}
                </div>
            </div>
        </div>
        <div>
            <v-date-picker
                    no-title
                    :locale="locale"
                    v-model="date_start"
                    :max="max_date"
                    reactive>
            </v-date-picker>
            <v-date-picker
                    no-title
                    :locale="locale"
                    v-model="date_end"
                    :min="min_date"
                    reactive>
            </v-date-picker>
        </div>
        <slot></slot>
    </div>
</template>
<style scoped>
    .card {
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
</style>

<script>
    export default {
        name: 'RangeDatePicker',
        props: ['locale', 'value'],
        data: () => ({
            date_start: null,
            date_end: null,
            min_date: null,
            max_date: null,
        }),
        mounted() {
            this.date_start = this.value.start;
            this.date_end = this.value.end;
        },
        computed: {
            range() {
                let value = null;
                if (this.date_start && this.date_end) {
                    value = this.date_start + " ~ " + this.date_end;
                }

                this.$emit('input', {
                    start: this.date_start,
                    end: this.date_end
                });
                return value;
            },
        },
        watch: {
            date_start(new_val, old_val) {
                this.min_date = new_val;
                if (!this.date_end) {
                    this.date_end = new_val;
                }
            },
            date_end(new_val, old_val) {
                this.max_date = new_val;
                if (!this.date_start) {
                    this.date_start = new_val;
                }
            }
        },
    }
</script>